import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  // selectNewRequestBargiryDate,
  // selectNewRequestBargiryTime,
  selectNewRequestTakhliehDate,
  selectNewRequestTakhliehTime,
  selectNewRequestTakhliehTimeTo,
} from "../../redux/newRequest/newRequest.selectors";

import "antd/dist/antd.css";

import { TimePicker } from "antd";
// import TimePicker from "react-time-picker";
// import TimePicker from "react-time-picker/dist/entry.nostyle";

// import { toPersianNum } from "../../assets/utils";
import { TakhliehTimeInputsStyled } from "./TakhliehTimeInputs.styles";
import {
  // setBargiryTime,
  // setCalenderBargiryShow,
  setCalenderTakhliehShow,
  setTakhliehTime,
  setTakhliehTimeTo,
} from "../../redux/newRequest/newRequest.actions";

const TakhliehTimeInputs = ({
  selectNewRequestTakhliehDate,
  selectNewRequestTakhliehTime,
  selectNewRequestTakhliehTimeTo,

  setCalenderBargiryShow,
  setCalenderTakhliehShow,

  setTakhliehTime,
  setTakhliehTimeTo,

  setBargiryTime,
}) => {
  const handle_timepicker_change = (time) => {
    setTakhliehTime(time);
  };
  const handle_timepicker2_change = (time) => {
    setTakhliehTimeTo(time);
  };

  // const handle_dateInput_click = () => {
  //   setCalenderTakhliehShow(true);
  // };

  return (
    <TakhliehTimeInputsStyled className="mt-3 w-100 d-flex align-items-center justify-content-between">
      <div className="flex-basis--50">
        {/* <input
          type="text"
          placeholder="ساعت بارگیری"
          className="input--custom w-100"
          value={
            selectNewRequestBargiryTime &&
            toPersianNum(selectNewRequestBargiryTime.value)
          }
          readOnly
        /> */}
        <TimePicker
          style={{ direction: "ltr" }}
          className="input--custom text-center"
          placeholder="ساعت بارگیری از"
          format="HH:mm"
          direction="ltr"
          onChange={(time) => handle_timepicker_change(time)}
          value={selectNewRequestTakhliehTime}
        />
      </div>
      <div className="flex-basis--50">
        <TimePicker
          style={{ direction: "ltr" }}
          className="input--custom text-center"
          placeholder="ساعت بارگیری تا"
          format="HH:mm"
          direction="ltr"
          onChange={(time) => handle_timepicker2_change(time)}
          value={selectNewRequestTakhliehTimeTo}
        />
      </div>
    </TakhliehTimeInputsStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestTakhliehDate: selectNewRequestTakhliehDate,
  selectNewRequestTakhliehTime: selectNewRequestTakhliehTime,
  selectNewRequestTakhliehTimeTo: selectNewRequestTakhliehTimeTo,
});

const mapDispatchToProps = (dispatch) => ({
  setCalenderTakhliehShow: (x) => dispatch(setCalenderTakhliehShow(x)),

  setTakhliehTime: (x) => dispatch(setTakhliehTime(x)),
  setTakhliehTimeTo: (x) => dispatch(setTakhliehTimeTo(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TakhliehTimeInputs);
